var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.1895L32.9341 38.9547L61.9078 21.7976L62 48.2299L32.7767 65.0002L0 45.565V19.1895Z",
    fill: "#2D2F76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9341 38.9545L61.9078 21.7975L29.3608 2.13208L0 19.1893L32.9341 38.9545Z",
    fill: "#5459A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7768 17.8633C28.8887 17.8633 25.7368 20.1001 25.7368 22.8595V27.6554C25.7368 30.4147 28.8887 32.6516 32.7768 32.6516C36.6648 32.6516 39.8167 30.4147 39.8167 27.6554V22.8595C39.8167 20.1001 36.6648 17.8633 32.7768 17.8633Z",
    fill: "#2D2F76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7768 27.8556C36.6648 27.8556 39.8167 25.6188 39.8167 22.8595C39.8167 20.1001 36.6648 17.8633 32.7768 17.8633C28.8887 17.8633 25.7368 20.1001 25.7368 22.8595C25.7368 25.6188 28.8887 27.8556 32.7768 27.8556Z",
    fill: "#8E94DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9828 8.07104C12.0948 8.07104 8.94287 10.3079 8.94287 13.0672V17.8632C8.94287 20.6225 12.0948 22.8594 15.9828 22.8594C19.8709 22.8594 23.0228 20.6225 23.0228 17.8632V13.0672C23.0228 10.3079 19.8709 8.07104 15.9828 8.07104Z",
    fill: "#2D2F76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9828 18.0634C19.8709 18.0634 23.0228 15.8265 23.0228 13.0672C23.0228 10.3079 19.8709 8.07104 15.9828 8.07104C12.0948 8.07104 8.94287 10.3079 8.94287 13.0672C8.94287 15.8265 12.0948 18.0634 15.9828 18.0634Z",
    fill: "#8E94DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1137 -1C27.2256 -1 24.0737 1.23687 24.0737 3.99619V8.79214C24.0737 11.5515 27.2256 13.7883 31.1137 13.7883C35.0017 13.7883 38.1537 11.5515 38.1537 8.79214V3.99619C38.1537 1.23687 35.0018 -1 31.1137 -1Z",
    fill: "#2D2F76"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1137 8.99236C35.0018 8.99236 38.1536 6.7555 38.1536 3.99618C38.1536 1.23687 35.0018 -1 31.1137 -1C27.2256 -1 24.0737 1.23687 24.0737 3.99618C24.0737 6.7555 27.2256 8.99236 31.1137 8.99236Z",
    fill: "#8E94DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0561 8.79211C44.168 8.79211 41.0161 11.029 41.0161 13.7883V18.5842C41.0161 21.3436 44.168 23.5804 48.0561 23.5804C51.9441 23.5804 55.096 21.3436 55.096 18.5842V13.7883C55.096 11.029 51.9441 8.79211 48.0561 8.79211Z",
    fill: "#2D2F76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0561 18.7845C51.9441 18.7845 55.096 16.5476 55.096 13.7883C55.096 11.029 51.9441 8.79211 48.0561 8.79211C44.168 8.79211 41.0161 11.029 41.0161 13.7883C41.0161 16.5476 44.168 18.7845 48.0561 18.7845Z",
    fill: "#8E94DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/Basic.52ecba96bea4cf536edc84c2406ba63f.svg";
export { ForwardRef as ReactComponent };